export type RelativeTime = { unit: 'justNow' } | { unit: 'minutes' | 'hours' | 'days'; n: number };

export function relativeTimeUnit(iso: string, now: number = Date.now()): RelativeTime {
  const seconds = Math.max(0, Math.floor((now - new Date(iso).getTime()) / 1000));
  if (seconds < 60) return { unit: 'justNow' };
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return { unit: 'minutes', n: minutes };
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return { unit: 'hours', n: hours };
  return { unit: 'days', n: Math.floor(hours / 24) };
}
